import { useLang } from 'hooks/lang';

import { Tooltip } from 'components/Blocks';
import { CalendarDaysIcon } from 'components/Icons';

import { useTaskModal } from '../context.taskModal';
import { useModalsTaskOption } from '../taskModalOption.hook';

import { formatDate } from 'utils/date';

export function TaskDate() {
  const { t } = useLang();
  const { task } = useTaskModal();

  const changeDate = useModalsTaskOption('REQUEST_DATE_CHANGE');

  if (!task.expectedDate) return null;

  return (
    <Tooltip
      content={
        <span>
          <span className="font-medium italic">{t('due-date')}: </span>
          {changeDate.isEnabled ? t('change') : t('final')}
        </span>
      }
    >
      <button
        disabled={!changeDate.isEnabled}
        onClick={changeDate.action}
        className="inline-flex items-center gap-2 rounded-sm bg-primary-light px-3 py-0.5 text-sm text-primary-foreground transition-colors hover:bg-primary"
      >
        <CalendarDaysIcon size={16} className="-translate-y-[1px]" />

        <span>{formatDate(new Date(task.expectedDate))}</span>
      </button>
    </Tooltip>
  );
}
